import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcashButtonDisabled, InputActive, MarketplaceActionsComponent } from './marketplace-actions.component';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { NumberInputModule } from '@fgb/portal-component-library/src/lib/shared/number-input';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { InlineSVGModule } from 'ng-inline-svg-2';

@NgModule({
  declarations: [MarketplaceActionsComponent, InputActive, EcashButtonDisabled],
  imports: [
    CommonModule,
    NumberInputModule,
    DirectivesModule,
    ErrorsModule,
    InlineSVGModule,
    FGBSharedModule
  ],
  exports: [MarketplaceActionsComponent],
})
export class MarketplaceActionsModule {}
